<template>
  <div style="margin: 10px">
    <v-form
      direction="horizontal"
      :model="jsaddForm"
      :rules="jsaddRules"
      ref="jsaddRuleForm"
    >
      <!-- <v-form-item label="销方名称" :label-col="labelCol" :wrapper-col="wrapperCol">
        <span>{{jsaddForm.xfmc}}</span>
      </v-form-item> -->
      <v-form-item
        label="菜单名称"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        prop="cd_mc"
        has-feedback
      >
        <v-input v-model="jsaddForm.cd_mc" placeholder="菜单名称"></v-input>
      </v-form-item>
      <v-form-item
        label="菜单路由"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <v-input v-model="jsaddForm.cd_url" placeholder="菜单路由"></v-input>
      </v-form-item>
      <v-form-item
        label="菜单父节点"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <v-select
          style="width: 250px"
          dropdown-width="240px"
          :data="pmenu_options"
          v-model="jsaddForm.pid"
         
        >
        </v-select>
      </v-form-item>
      <v-form-item label="图标" :label-col="labelCol" :wrapper-col="wrapperCol">
        <v-input v-model="jsaddForm.icon" placeholder="图标"></v-input>
      </v-form-item>
      <v-form-item
        label="菜单排序号"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <v-input v-model="jsaddForm.px" placeholder="排序号"></v-input>
      </v-form-item>
      <v-form-item
        label="启用"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-switch v-model="jsaddForm.xy_bz"></v-switch>
      </v-form-item>
    </v-form>
    <div style="text-align: center">
      <v-button type="success" icon="save" @click="save('jsaddRuleForm')"
        >保存</v-button
      >
      <v-button type="error" icon="close-circle-o" @click="cancel"
        >取消</v-button
      >
    </div>
  </div>
</template>

<script>
let jsaddForm = {
  cd_mc: "",
  cd_url: "",
  icon: "",
  px: "",
  pid: "",
  xy_bz: true
  // xfid: ""
};
let old_rolename = "";
export default {
  data() {
    return {
      pmenu_options: [],
      jsaddRules: {
        js_mc: [
          {
            required: true,
            message: "请输入菜单名称!"
          }
        ]
      },
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 14
      },
      jsaddForm,
      old_rolename
    };
  },
  created() {
    //alert(this.$route.query.id)
    this.init_menu();
    if (this.$route.query.id) {
      this.jsaddForm.id = this.$route.query.id;
      this.init();
    }
  },
  methods: {
    init_menu: function () {
         this.$axios.get("api/system/qxgl/get-menu-list-par").then(res => {
        let self = this;
        if (res.data.code == 200) {
          self.pmenu_options = res.data.data.map(item => {
            return { value: item.id, label: item.cd_mc };
          });
        }
      });
    },
    init: function () {
      this.$axios.get("api/system/qxgl/get-menu-first/" + jsaddForm.id).then(res => {
        let self = this;
        if (res.data.data.xy_bz == "1") {
          res.data.data.xy_bz = true
        }
        self.jsaddForm = res.data.data;
        self.old_rolename = self.jsaddForm.rolename;
      });
    },
    save: function (formName) {
      // this.$refs[formName].validate(valid => {
      //   if (valid) {
      this.$axios.post("api/system/qxgl/set-menu-first", this.jsaddForm).then(res => {
        if (res.data.code == 200) {
          this.$message["success"](res.data.message);
          xadmin.close();
          xadmin.father_reload();
        } else {
          this.$message["error"](res.data.message);
        }
      });
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    cancel: function () {
      xadmin.close();
      xadmin.father_reload();
    }
  }
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/qxgl/cdwhadd.vue